// https://github.com/FlutterInt/fips-shared-protocols/blob/master/tourndef.h

// prettier-ignore
enum TournFlags2 {
  TOURNSCRIPT_FLAG2_OPTEARLYSTART = 0x0001,                       // (ONE64 <<  0)
  TOURNSCRIPT_FLAG2_OPTSKIPBREAK = 0x0002,                        // (ONE64 <<  1)
  TOURNSCRIPT_FLAG2_SYNCBREAKS_EVEN = 0x0004,                     // (ONE64 <<  2)
  TOURNSCRIPT_FLAG2_SYNCBREAKS_ODD = 0x0008,                      // (ONE64 <<  3)
  TOURNSCRIPT_FLAG2_PACKEDLOSERSOUT	= 0x0010,                     // (ONE64 <<  4)
  TOURNSCRIPT_FLAG2_NSTACK	= 0x0020,                             // (ONE64 <<  5)
  TOURNSCRIPT_FLAG2_MILESTONE = 0x0040,                           // (ONE64 <<  6)
  TOURNSCRIPT_FLAG2_SPINANDGO	= 0x0080,                           // (ONE64 <<  7)
  TOURNSCRIPT_FLAG2_FLIGHT_ENTRY = 0x0100,                        // (ONE64 <<  8)
  TOURNSCRIPT_FLAG2_FLIGHT_INTERMEDIATE	= 0x0200,                 // (ONE64 <<  9)
  TOURNSCRIPT_FLAG2_FLIGHT_FINAL = 0x0400,                        // (ONE64 << 10)
  TOURNSCRIPT_FLAG2_TABLE_SUBSCRIPTION_OVER_CONNECTION = 0x0800,  // (ONE64 << 11)
  TOURNSCRIPT_FLAG2_BLINDS_INCREASE_INTERVAL_HANDS = 0x1000,      // (ONE64 << 12)
  TOURNSCRIPT_FLAG2_POWERSUP_ENABLED = 0x2000,                    // (ONE64 << 13)
  TOURNSCRIPT_FLAG2_HTML5_ALLOWED = 0x4000,                       // (ONE64 << 14)
  TOURNSCRIPT_FLAG2_CUSTOM_PRIZES = 0x8000,                       // (ONE64 << 15)
  TOURNSCRIPT_FLAG2_SAG_FREEROLL_PM_DUP = 0x10000,                // (ONE64 << 16)
  TOURNSCRIPT_FLAG2_PSNG = 0x20000,                               // (ONE64 << 17)
  TOURNSCRIPT_FLAG2_KNOCKOUT = 0x40000,                           // (ONE64 << 18)
  TOURNSCRIPT_FLAG2_PSNG_REMATCH = 0x80000,                       // (ONE64 << 19)
  TOURNSCRIPT_FLAG2_BEAT_THE_CLOCK = 0x100000,                    // (ONE64 << 20)
  TOURNSCRIPT_FLAG2_WIN_THE_BUTTON = 0x200000,                    // (ONE64 << 21)
  // TOURNSCRIPT_FLAG2_STORMLOBBY = 0x400000,                     // (ONE64 << 22)
  TOURNSCRIPT_FLAG2_RESTRICTED_TO_NON_QUALIFIERS = 0x800000,      // (ONE64 << 23)
  TOURNSCRIPT_FLAG2_FORCE_TO_TOP = 0x1000000,                     // (ONE64 << 24)
  TOURNSCRIPT_FLAG2_FORCE_TO_TOP_STICKY = 0x2000000,              // (ONE64 << 25)
  TOURNSCRIPT_FLAG2_SPINANDGOMAX = 0x4000000,                     // (ONE64 << 26)
  // TOURNSCRIPT_FLAG2_SERVER7 = 0x8000000,                       // (ONE64 << 27)
  TOURNSCRIPT_FLAG2_EARLY_PAYOUTS = 0x10000000,                   // (ONE64 << 28)
  // TOURNSCRIPT_FLAG2_STORM_BETATESTER = 0x20000000,             // (ONE64 << 29)
  TOURNSCRIPT_FLAG2_FLOPSTARS = 0x40000000,                       // (ONE64 << 30)
  TOURNSCRIPT_FLAG2_SUPPORTS_INTERNAL_ACCOUNTS = 0x80000000,      // (ONE64 << 31)
  // TOURNSCRIPT_FLAG2_USE_OLD_TABLE_SERVER = 0x100000000,        // (ONE64 << 32)
  TOURNSCRIPT_FLAG2_WINNER_ANIMATION = 0x200000000,               // (ONE64 << 33)
  TOURNSCRIPT_FLAG2_INTHEMONEY_ANIMATION = 0x400000000,           // (ONE64 << 34)
  TOURNSCRIPT_FLAG2_BUTTON_BLIND = 0x800000000,                   // (ONE64 << 35)
  TOURNSCRIPT_FLAG2_FORCE_WINNER_TO_SHOW = 0x1000000000,          // (ONE64 << 36)
  TOURNSCRIPT_FLAG2_SAG_FLASH = 0x2000000000,                     // (ONE64 << 37)
  TOURNSCRIPT_FLAG2_TOURNSERVER7 = 0x4000000000,                  // (ONE64 << 38)
  TOURNSCRIPT_FLAG2_PROGRESSIVEPLUS = 0x8000000000,               // (ONE64 << 39)
  TOURNSCRIPT_FLAG2_HIGHROLLER = 0x10000000000,                   // (ONE64 << 40)
  TOURNSCRIPT_FLAG2_SIMULTANEOUS_ACTION_POKER = 0x20000000000,    // (ONE64 << 41)
  TOURNSCRIPT_FLAG2_APEXTOURN = 0x40000000000,                    // (ONE64 << 42)
  TOURNSCRIPT_FLAG2_BIGPRIZEPOOL = 0x80000000000,                 // (ONE64 << 43)
  TOURNSCRIPT_FLAG2_FORCE_MUCK = 0x100000000000,                  // (ONE64 << 44)
  TOURNSCRIPT_FLAG2_FORCETOTOP_NOFILTER = 0x200000000000,         // (ONE64 << 45)
  TOURNSCRIPT_FLAG2_VIDEO_CHAT = 0x400000000000,                  // (ONE64 << 46)
  TOURNSCRIPT_FLAG2_FLIGHT2 = 0x800000000000,                     // (ONE64 << 47)
  TOURNSCRIPT_FLAG2_PL_ANTE_IN_PREFLOP_POT = 0x1000000000000,     // (ONE64 << 48)
  TOURNSCRIPT_FLAG2_MYSTERY_BOUNTY = 0x2000000000000,             // (ONE64 << 49)
  TOURNSCRIPT_FLAG2_SPINANDGO_6MAX = 0x4000000000000,             // (ONE64 << 50)
}

export default TournFlags2;
